export const SET_USER = 'SET_USER';

export const SetUser = (payload) => {
    return {
        type: SET_USER,
        payload
    }
}